<template>
  <v-form @submit.prevent="upsertTimeOff" ref="form">
    <v-card dense class="rounded-4">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold" v-if="mode=='Add'">Add Personal Time Off</span>
            <span class="font-weight-bold" v-else>Edit Personal Time Off</span>
            <v-spacer></v-spacer>
            <help-link appId="attendance" pageId="timeoff-daily" color="black"></help-link>
            <v-btn icon @click.native="closeDialog">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
            Error encountered. Please contact support. Error details: {{errorMessage}}
        </v-alert>
        <v-card-text dense>
            <v-alert v-if="status==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline style="margin:0px 20px 10px 20px;">
                This is alraedy approved. Clicking Save will update back to For Review.
            </v-alert>  
            <v-alert v-if="!validInputHours" :value="true" color="error" icon="error" outline style="margin:0px 20px 10px 20px;">
                Input hours is greater than the available balance.
            </v-alert>
            <v-layout row wrap>
                <v-flex xs12 sm12 class="form-content">  
                    <v-layout row>  
                        <v-flex xs12 sm6 style="margin-right:15px;">
                            <v-text-field 
                                label="Date"
                                v-model="transDate" 
                                disabled
                                ></v-text-field>  
                        </v-flex>      
                        <v-flex xs12 sm6 style="margin-left:15px;">
                            <v-text-field 
                                label="Hours"
                                v-model="hours" 
                                :rules="[rules.required, rules.valid_hours]" 
                                type="number" min="0" maxlength="8" step="0.25" value="0.00"
                                @blur="formatHours"
                                ></v-text-field>  
                            <div style="margin-top:-20px;" class="text-xs-right"><small>In decimal format. (1.5 = 1hour 30mins)</small></div>
                        </v-flex>
                    </v-layout>
                    <v-layout row> 
                        <v-flex xs12 sm12>
                            <v-autocomplete
                                label = "Type"
                                v-model="leaveTypeId"
                                :disabled="disabled"
                                :items="leaves_allocation"
                                :rules="[rules.required]"
                                chips
                                color="primary lighten-2"
                                item-text="leaveName"
                                item-value="leaveTypeId"
                                @change="formatHours" 
                                >
                                <template v-slot:selection="data">
                                    <v-chip :selected="data.selected" class="chip--select-multi">
                                        {{ data.item.leaveName }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                    </template>
                                    <template v-else>
                                        <v-list-tile-content>
                                            <v-list-tile-title v-html="data.item.leaveName"></v-list-tile-title>
                                            <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-flex>      
                    </v-layout>
                    <v-layout row style="margin:20px 0px 0px 0px;">  
                        <v-flex xs12>
                            <v-textarea v-model="remarks" 
                                :rules="[rules.required]"  
                                maxlength="150"
                                hint="150 characters max"
                                label="Remarks" rows="1" color="primary"></v-textarea>
                        </v-flex>      
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="mode=='Add'" @click="clearForm" :disabled="disabled">Clear</v-btn>
            <v-btn color="primary" type="submit" :loading="loading" :disabled="disabled" class="mr-25">
                <span v-if="mode=='Add'">Save</span>
                <span v-if="mode=='Edit'">Update</span>
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

import timeOffsApi from '@/api/timeoffs'
import leavesAllocationApi from '@/api/leavesallocation'
import commonfn from '@/common/functions'   //for refactor

export default {
    data() {
        return {
            commonfn,
            error: false,
            errorMessage: '',
            transDate: '',
            workShift: '',
            disabled: false,
            loading: false,
            rules: {
                required: value => !!value || 'Required.',
                valid_hours: value => value > 0 || 'Should be greater than zero',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                } 
            },        
            remarks: '',
            status: '',
            mode: '',
            duration: '',
            leaveTypeId: null,
            hours: null,
            timeOffId: null,
            leaves_allocation: [],
            validInputHours: true,
            includeWeekends: false,
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {
        formatHours() {
            this.validInputHours = true
            
            if (this.hours > 8) this.hours = 8

            if (this.hours!=null && this.hours!=NaN && this.hours!='') {
                var test = parseFloat(this.hours).toFixed(2);
                this.hours = test
            }

            //check validInputHours
            var selected = this.leaves_allocation.filter(x => {
                return x.leaveTypeId == this.leaveTypeId
            })[0]
            
            if (selected.balanceHours!=-1) { 
                if (selected.balanceHours < parseFloat(this.hours)) this.validInputHours = false
            }
        },
        async setParams(data) {
            this.mode = data.mode

            if (this.mode=='Add') {
                this.clearForm()
                this.transDate = this.$moment(data.transDate).format('YYYY-MM-DD')
                this.workShift = data.workShift
            }else{
                this.timeOffId = data.timeOffId
                this.transDate = this.$moment(data.transDate).format('YYYY-MM-DD')
                this.workShift = data.workShift
                this.leaveTypeId = data.type
                this.hours = data.hours
                this.remarks = data.remarks
            }

            if (this.transDate) {
                const day = this.$moment(this.transDate).day()
                this.includeWeekends = (day === 0 || day === 6)
                await this.getAvailableLeaves()
            }
        },
        async getAvailableLeaves() {
            try{
                this.leaves_allocation = []
                const response = await leavesAllocationApi.getAvailable(this.transDate)
                if (response && response.status == 200) {
                    //need to hide leaves with zero balance. if prorated, only earned can be used

                    response.data.items.forEach(item => {
                        var balanceHours = item.earnedHours>item.balanceHours?item.balanceHours:item.earnedHours
                        this.leaves_allocation.push({
                            leaveTypeId: item.leaveTypeId,
                            balanceHours: balanceHours,
                            leaveName: item.earnedHours==-1? item.leaveName : `${item.leaveName} (${balanceHours} hrs available)`
                        })
                    })
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async upsertTimeOff() {
            try {
                if (this.$refs.form.validate() && this.validInputHours) {
                    
                    this.loading = true
                    this.disabled = true

                    const data = {
                        timeOffId: this.timeOffId,
                        transDate: this.transDate,
                        endDate: this.transDate, //This to support date range option in My TimeOff page.
                        hours: this.hours,
                        type: this.leaveTypeId,
                        includeWeekends: this.includeWeekends,
                        remarks: this.remarks
                    }
                    var response = null

                    if (this.mode=='Add')
                        response = await timeOffsApi.add(data)
                    else
                        response = await timeOffsApi.update(data)
                        
                    if (response && response.status == 200) {
                        this.$emit('send',null)
                    }
                    this.loading = false
                    this.disabled = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        clearForm() {
            this.loading = false
            this.error = false
            this.validInputHours = true
            this.hours = null
            this.leaveTypeId = null
            this.remarks = ''
        },
        closeDialog() {
            this.$emit('update:dialogPTO', false)
        }
    },
    created() {},
    computed: {
        isWeekEnd() {
            const day = this.$moment(this.transDate).day()
            return (day === 0 || day === 6)
        }
    },
}
</script>
<style scoped>
.form-content {
    padding:10px 25px 0px 25px;
}
</style>